import React, { FC } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import { Grid, makeStyles } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Loading from "../../../components/Loading";
import Button from "../../../components/Button";
import { FormSwitch } from "./FormSwitch";
import { emailPreferencesConfigs } from "./constants";
import { EmailType } from "./types";

const useStyles = makeStyles(() => ({
  fieldContainer: {
    "& > .MuiFormControlLabel-root": {
      margin: "unset",
    },
  },
  divider: {
    marginTop: 8,
    marginBottom: 8,
  },
  description: {
    marginTop: 8,
    paddingLeft: 38,
    color: "rgb(109, 117, 141)",
    fontSize: 14,
  },
  updateContainer: {
    marginTop: 24,
    marginBottom: 24,
  },
}));

const EmailPreferencesForm: FC<FormRenderProps> = ({
  handleSubmit,
  submitError,
  submitting,
}) => {
  const classes = useStyles();
  const { values } = useFormState();
  const isModal = !!values.mode;

  return (
    <form noValidate onSubmit={handleSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      {submitting && <Loading />}
      {values.role !== undefined && (
        <>
          <div>
            {emailPreferencesConfigs[values.role].map((item) => (
              <div key={item.type} className={classes.fieldContainer}>
                <Field
                  disabled={
                    values.preferences[EmailType.All] &&
                    item.type !== EmailType.All
                  }
                  name={`preferences.${item.type}`}
                  type="checkbox"
                  label={item.label}
                  component={FormSwitch}
                />
                <Typography className={classes.description}>
                  {item.description}
                </Typography>
                <Hidden>
                  <Divider className={classes.divider} />
                </Hidden>
              </div>
            ))}
          </div>
          {!isModal && (
            <Grid
              className={classes.updateContainer}
              container
              spacing={3}
              alignItems={"center"}
              justify={"flex-end"}
            >
              <Grid item sm={5} xs={12}>
                <Button
                  fullWidth
                  type="submit"
                  color="secondary"
                  variant="contained"
                  disabled={submitting}
                >
                  Update email preferences
                </Button>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </form>
  );
};

export default EmailPreferencesForm;
